import AdjustmentRecord from './UILibrary/HYBElement/AdjustmentRecord'
import AutoJobNumber from './UILibrary/HYBElement/AutoJobNumber'
import BigDataSelect from './UILibrary/HYBElement/BigDataSelect'
import ButtonGroup from './UILibrary/HYBElement/ButtonGroup'
import CalendarCascader from './UILibrary/HYBElement/CalendarCascader'
import CalendarDatePicker from './UILibrary/HYBElement/CalendarDatePicker'
import CalendarRangeDatePicker from './UILibrary/HYBElement/CalendarRangeDatePicker'
import CardSelect from './UILibrary/HYBElement/CardSelect'
import Cascader from './UILibrary/HYBElement/Cascader'
import CheckboxSelect from './UILibrary/HYBElement/CheckboxSelect'
import CityCascader from './UILibrary/HYBElement/CityCascader'
import Concat from './UILibrary/HYBElement/Contact'
import Contract from './UILibrary/HYBElement/Contract'
import DatePickerAll from './UILibrary/HYBElement/DatePickerAll'
import DatetimePickerBox from './UILibrary/HYBElement/DatetimePickerBox'
import DynamicsElement from './UILibrary/HYBElement/DynamicsElement'
import Education from './UILibrary/HYBElement/Education'
import FlowPath from './UILibrary/HYBElement/FlowPath'
import FormFileImage from './UILibrary/HYBElement/FormFileImage'
import FormImage from './UILibrary/HYBElement/FormImage'
import GroupSelect from './UILibrary/HYBElement/GroupSelect'
import HealthCertificate from './UILibrary/HYBElement/HealthCertificate'
import InputNumber from './UILibrary/HYBElement/InputNumber'
import InputNumberRange from './UILibrary/HYBElement/InputNumberRange'
import InputSelect from './UILibrary/HYBElement/InputSelect'
import InputTimeGroup from './UILibrary/HYBElement/InputTimeGroup'
import InputWithImage from './UILibrary/HYBElement/InputWithImage'
import ListSelect from './UILibrary/HYBElement/ListSelect'
import LocationSelect from './UILibrary/HYBElement/LocationSelect'
import ModelPage from './UILibrary/HYBElement/ModelPage'
import Organize from './UILibrary/HYBElement/Organize'
import OrganizeSelect from './UILibrary/HYBElement/OrganizeSelect'
import PersonalIncomeTaxInfo from './UILibrary/HYBElement/PersonalIncomeTaxInfo'
import PersonalInfo from './UILibrary/HYBElement/PersonalInfo'
import Personnel from './UILibrary/HYBElement/Personnel'
import PickerBox from './UILibrary/HYBElement/PickerBox'
import RelatedCard from './UILibrary/HYBElement/RelatedCard'
import Reshuffle from './UILibrary/HYBElement/Reshuffle'
import RewardPunishment from './UILibrary/HYBElement/RewardPunishment'
import RidioSelect from './UILibrary/HYBElement/RidioSelect'
import SearchSelect from './UILibrary/HYBElement/SearchSelect'
import Seat from './UILibrary/HYBElement/Seat'
import TemplateGenerate from './UILibrary/HYBElement/TemplateGenerate'
import TimeIntervalArray from './UILibrary/HYBElement/TimeIntervalArray'
import TimePicker from './UILibrary/HYBElement/TimePicker'
import TimeRangePicker from './UILibrary/HYBElement/TimeRangePicker'
import TodayPicker from './UILibrary/HYBElement/TodayPicker'
import ToolTip from './UILibrary/HYBElement/Tooltip'
import TrainingRecord from './UILibrary/HYBElement/TrainingRecord'
import TreeSelect from './UILibrary/HYBElement/TreeSelect'
import UniversalRecord from './UILibrary/HYBElement/UniversalRecord'
import Warnning from './UILibrary/HYBElement/Warnning'
import HCalendar from './UILibrary/HYBVant/HCalendar'
import HCell from './UILibrary/HYBVant/HCell'
import HInput from './UILibrary/HYBVant/HInput'
import HRadioGroup from './UILibrary/HYBVant/HRadioGroup'
import HRangeDatePicker from './UILibrary/HYBVant/HRangeDatePicker'
import HSwitch from './UILibrary/HYBVant/HSwitch'
import HTextArea from './UILibrary/HYBVant/HTextArea'

/**
 * 组件映射
 */
const mapping: { [key: string]: any } = {
  BigDataSelect,
  Cell: HCell,
  DatePicker: DatetimePickerBox,
  RangeDatePicker: HRangeDatePicker,
  Input: HInput,
  InputNumber,
  Picker: PickerBox,
  Select: ListSelect,
  RadioGroup: HRadioGroup,
  Textarea: HTextArea,
  TextArea: HTextArea,
  Switch: HSwitch,
  FormImage,
  FormFileImage,
  Education,
  AdjustmentRecord,
  HealthCertificate,
  RewardPunishment,
  PersonalIncomeTaxInfo,
  TrainingRecord,
  UniversalRecord,
  Concat,
  ModelPage,
  FlowPath,
  Cascader,
  OrganizeSelect,
  RidioSelect,
  TodayPicker,
  GroupSelect,
  LocationSelect,
  InputWithImage,
  CityCascader,
  Personnel,
  Organize,
  Reshuffle,
  ButtonGroup,
  Seat,
  SearchSelect,
  InputNumberRange,
  Calendar: HCalendar,
  InputSelect,
  CheckboxSelect,
  DatePickerAll,
  TimePicker,
  CalendarCascader,
  CalendarDatePicker,
  ListSelect,
  RelatedCard,
  CalendarRangeDatePicker,
  CardSelect,
  TreeSelect,
  TimeRangePicker,
  ToolTip,
  Warnning,
  InputTimeGroup,
  Contract,
  AutoJobNumber,
  PersonalInfo,
  DynamicsElement,
  TimeIntervalArray,
  TemplateGenerate
}
export default mapping
